<template>
  <div class="auth-mark" :style="markStyles">
    <img class="wh100" src="@/assets/img/auth-mark.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "auth-mark",
  props: {
    size: {
      type: String,
      default: "16px",
    },
  },
  computed: {
    markStyles() {
      return {
        "--mark-width": this.$props.size,
        "--mark-height": this.$props.size,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.auth-mark {
  font-size: 0;
  vertical-align: middle;
  display: inline-block;
  width: 16px;
  height: 16px;
  width: var(--mark-width);
  height: var(--mark-height);
}
</style>
